// src/App.js

import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import LoginScreen from "./components/LoginScreen";       //ログイン画面
import InventoryApp from "./components/InventoryApp";     //在庫管理・持ち出し画面
import InventoryOrder from "./components/InventoryOrder"; //在庫管理・発注依頼画面
import OrderRequestViewer from "./components/OrderRequestViewer";//発注一覧表示スマホ用

function App() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleLogin = (userInfo) => setUser(userInfo);
  const handleLogout = () => setUser(null);

  return (
    <AnimatePresence mode="wait">
      <Routes>
        {/* ログイン */}
        <Route
          path="/"
          element={
            <motion.div
              key="login"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.3 }}
            >
              <LoginScreen onLogin={handleLogin} />
            </motion.div>
          }
        />

        {/* 在庫管理（ログイン必須） */}
        <Route
          path="/inventory"
          element={
            user ? (
              <motion.div
                key="inventory"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <InventoryApp user={user} onLogout={handleLogout} />
              </motion.div>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 発注依頼（管理者のみ） */}
        <Route
          path="/order"
          element={
            user?.isAdmin ? (
              <motion.div
                key="order"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <InventoryOrder
                  user={user}
                  onLogout={handleLogout}
                  onNavigateToCheckout={() => navigate("/inventory")}
                />
              </motion.div>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 発注依頼一覧表示　スマホ用 */}
        <Route path="/viewer" element={<OrderRequestViewer />} />

        {/* 不明なパスはログインへ */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
